import React from "react";
import VariacionPorPaisYMes from "../components/VariacionPorPaisYMes";
import VariacionPorProveedorMes from "../components/VariacionPorProveedorMes";

const Graficos = () => {
  return (
    <div
      className="graficos-container"
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(12, 1fr)", // Grid de 12 columnas
        gap: "20px",
        padding: "20px",
      }}
    >
      {/* Primer gráfico: Variación por Proveedor ocupa 6 columnas */}
      <div className="grafico" style={{ gridColumn: "span 6" }}>
        <VariacionPorProveedorMes />
      </div>
      {/* Segundo gráfico: Variación por País y Mes ocupa 6 columnas */}
      <div className="grafico" style={{ gridColumn: "span 6" }}>
        <VariacionPorPaisYMes />
      </div>
    </div>
  );
};

export default Graficos;
